
export enum IFrameMessageTypes {
    loginRequired = 'loginRequired',
    logout = 'logout',
    contentLoaded = 'contentLoaded',
    listenersReady = 'listenersReady',
    ticketResolved = 'ticketResolved',
    insufficientFounds = 'insufficientFounds',
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/games/virtuals/enums.ts